import { IBusinessPriorityUserInfoApi } from '../api/types'
import { IBusinessPriorityUserInfo } from '../model/types'

import { parseSeparatedString } from './parseSeparatedString'

export const mapBusinessPriorityUserInfoFromApi = (
  data: IBusinessPriorityUserInfoApi
): IBusinessPriorityUserInfo => ({
  availableActions: parseSeparatedString(data.AvailibleActions),
  market: data.Market,
  userId: data.UserID,
  viewType: data.ViewType,
})
